/**
 * Media Square — English (t('square.…'))
 */
export default {
	breadcrumb: "Media Square",
	tabs: {
		ariaLabel: "Square content categories",
		all: "All",
		podcast: "Podcast",
		shorts: "Shorts",
		article: "Text & Image",
		creatorCenter: "Creator Hub",
	},
	index: {
		creatorCenterBtn: "+ Creator Hub",
	},
	recommend: {
		title: "Podcast",
		more: "More >",
		viewMorePodcast: "View more podcasts>",
	},
	shorts: {
		title: "Shorts",
		more: "More >",
	},
	article: {
		title: "Text & Image",
		more: "More >",
		viewMore: "View more",
		defaultAuthor: "Seer",
	},
	podcast: {
		defaultAuthor: "Life Guide",
	},
	views: {
		count: "{count} views",
		tenThousand: "{count}0K views",
		simple: "{count} views",
	},
	load: {
		more: "Load more",
		showMore: "Tap to show more",
		loading: "Loading...",
		done: "All content loaded",
	},
	empty: {
		text: "No content yet",
	},
	pagination: {
		ariaLabel: "Content pagination",
		prev: "Previous page",
		next: "Next page",
	},
	creatorApp: {
		title: "Seer App",
		desc: "This feature is only available in the app. Please open the app and sign in to continue.",
		download: "Download App",
		open: "Open App",
		close: "Close",
	},
	filter: {
		all: "All",
	},
	contentType: {
		video: "Video",
		article: "Article",
	},
	categories: {
		1: "Love & Marriage",
		2: "Career & Wealth",
		3: "Chinese Zodiac",
		4: "Astrology & Tarot",
		5: "Family & Health",
		6: "Feng Shui",
		7: "Paranormal",
		8: "Crystal Guide",
	},
	detail: {
		breadcrumb: "Square Detail",
		pageTitle: "Square Detail - Seer",
		seo: {
			defaultTitle: "Media Square",
			keywordsSuffix: "fortune telling, life guidance, destiny reading",
			descriptionSuffix:
				"Seer — professional life guidance platform with accurate readings and forecasts.",
			descriptionShort: "Seer professional life guidance platform",
		},
		follow: "+ Follow",
		followed: "Following",
		like: "Like",
		share: "Share",
		copyLink: "Copy link",
		copyLinkSuccess: "Link copied",
		copyLinkFailed: "Failed to copy link. Please try again.",
		shareTo: "Share to {platform}",
		sharePlatform: "social platform",
		comments: "Comments",
		authorTag: "Author",
		commentPlaceholder: "Say something...",
		send: "Send",
		sending: "Sending...",
		replyPlaceholder: "Reply to {'@'}{nickname}",
		loading: "Loading...",
		collapseReplies: "Hide replies",
		viewReplies: "View {count} replies",
		loadMoreReplies: "Load more replies",
		emptyComments: "No comments yet",
		emptyRecommend: "No related podcasts~",
		loadMoreComments: "Load more comments",
		commentSuccess: "Comment posted",
		commentFailed: "Failed to post comment. Please try again.",
		replySuccess: "Reply posted",
		replyFailed: "Failed to post reply. Please try again.",
		loginRequired: "Please log in first",
		actionFailed: "Action failed. Please try again.",
		shareTexts: [
			"Check out this interesting content!",
			"Come join the conversation~",
			"This share is too good to miss!",
		],
		video: {
			playAria: "Play video: {title}",
			coverAlt: "{title} video cover",
			playButtonAlt: "Play button",
			youtubePlayAria: "Play YouTube video: {title}",
			youtubeTitle: "YouTube video: {title}",
		},
		article: {
			coverAlt: "{title} cover",
		},
		articleSidebar: {
			hotTitle: "Hot Content",
			contactTeacher: "Contact Teacher",
			yearsExperience: "Experience",
			serviceCount: "Clients Served",
			rating: "Rating",
		},
		articleTeacher: {
			consultCount: "({count} consultations)",
		},
		shorts: {
			description: "Description",
			tabHot: "Most Popular",
			tabNew: "Latest",
			collapse: "Collapse",
		},
	},
};
